import {
	PlacementPreviewProvider as PlacementPreviewProviderRemote,
	createPreviewFetch as createPreviewFetchRemote,
} from '@atlassian/post-office-placement-preview-provider';
import type { EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';

export {
	PLACEMENT_REQUEST_URL,
	PREVIEW_REQUEST_URL,
	createReturnOverrideFetch,
} from '@atlassian/post-office-placement-preview-provider';

export const PlacementPreviewProvider = PlacementPreviewProviderRemote<EligibleMessage>;

export const createPreviewFetch = createPreviewFetchRemote<EligibleMessage>;
